import t from "./highrise1600.mjs";
import a from "./highrise1416.mjs";
import u from "./highrise648.mjs";
import o from "./highrise1532.mjs";
import e from "./highrise1420.mjs";
import g from "./highrise1347.mjs";
function P(r, m, s) {
  m = t(m, r);
  for (var n = -1, i = m.length, f = !1; ++n < i; ) {
    var l = g(m[n]);
    if (!(f = r != null && s(r, l)))
      break;
    r = r[l];
  }
  return f || ++n != i ? f : (i = r == null ? 0 : r.length, !!i && e(i) && o(l, i) && (u(r) || a(r)));
}
export {
  P as default
};
